import script from "./RulesTable.vue?vue&type=script&setup=true&lang=js"
export * from "./RulesTable.vue?vue&type=script&setup=true&lang=js"

import "./RulesTable.vue?vue&type=style&index=0&id=17921676&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17921676"]])

export default __exports__